import qs from 'qs'
import { useApi } from '../composables'
import http from '../composables/src/useHttp'

export const getAllTickets = (
  {
    limit = 10,
    page = 1,
    statusId,
    search,
    sortBy = 'createdAt',
    sortOrder = 'desc',
    ...extraQueryParams
  }: {
    limit: number | undefined
    page: number | null | undefined
    statusId?: string
    search?: string
    sortBy?: string
    sortOrder?: string
    [key: string]: any
  } = {
    limit: 10,
    page: 1,
    sortBy: 'createdAt',
    sortOrder: 'desc',
  },
) => {
  const params = {
    limit,
    page,
    [`sort[${sortBy}]`]: sortOrder,
    ...extraQueryParams,
  }

  if (statusId) {
    params.statusId = statusId
  }
  if (search) {
    params.search = search
  }

  const categoryParam = params.statusCategory || params.statusCategoryId

  if (categoryParam) {
    params['statusCategory[in]'] = categoryParam
    delete params.statusCategory
    delete params.statusCategoryId
  }
  const serializedParams = qs.stringify(params, { arrayFormat: 'comma', encode: false })

  return useApi(http.get(`/tickets?${serializedParams}`))
}
export const fetchAllQueues = () => {
  return useApi(http.get(`/queues`))
}
export const updateQueue = (id: string, data: any) => {
  return useApi(http.patch(`/queues/${id}`, data))
}
export const deleteQueue = (id: string) => {
  return useApi(http.delete(`/queues/${id}`))
}
export const createQueue = (data: any) => {
  return useApi(http.post(`/queues`, data))
}
export const updateQueuePositions = (positions: { id: string; position: number }[]) => {
  return useApi(http.put(`/queues/positions`, { positions }))
}

export const reorderTickets = (tickets: { id: string; sortOrder: number }[]) => {
  return useApi(http.patch(`/tickets/reorder`, { tickets }))
}

export const deleteTickets = (id: number) => {
  return useApi(http.delete(`/tickets/${id}`))
}
export const createTickets = (data: any) => {
  return useApi(http.post(`/tickets`, data))
}

export const getTicketHistory = (id: string, options?: { since?: string; etag?: string }) => {
  const params = options?.since ? `?since=${encodeURIComponent(options.since)}` : ''
  const headers: Record<string, string> = {}

  if (options?.etag) {
    headers['If-None-Match'] = options.etag
  }

  return useApi(http.get(`/tickets/${id}/history${params}`, { headers }))
}

export const updateTickets = (id: string, data: any) => {
  return useApi(http.patch(`/tickets/${id}`, data))
}

export const getTicket = (id: string) => {
  return useApi(http.get(`/tickets/${id}`))
}

export const updateStatus = (id: number, status: any) => {
  return useApi(http.put(`/tickets/${id}/status`, status))
}
export const updateAssignee = (id: number, assignee: any) => {
  return useApi(http.put(`/tickets/${id}/assignee`, assignee))
}
export const updatePriority = (id: number, priority: any) => {
  return useApi(http.put(`/tickets/${id}/priority`, priority))
}

export const addHoldReason = (id: string, data: { holdReason: string; notes?: string }) => {
  return useApi(http.patch(`/tickets/${id}/hold-reason`, data))
}

export const createJiraTicket = (ticketId: string) => {
  return useApi(http.post(`/tickets/${ticketId}/jira`, { ticketId }))
}

export const exportTickets = (
  {
    statusId,
    search,
    sortBy = 'createdAt',
    sortOrder = 'desc',
    range = 'all',
    ...extraQueryParams
  }: {
    statusId?: string
    search?: string
    sortBy?: string
    sortOrder?: string
    range?: string
    [key: string]: any
  } = {
    sortBy: 'createdAt',
    sortOrder: 'desc',
    range: 'all',
  },
) => {
  const params = {
    [`sort[${sortBy}]`]: sortOrder,
    ...extraQueryParams,
  }

  if (statusId) {
    params.statusId = statusId
  }
  if (search) {
    params.search = search
  }
  if (range) {
    params.range = range
  }
  const serializedParams = qs.stringify(params, { arrayFormat: 'comma', encode: false })

  return useApi(http.get(`/tickets/export?${serializedParams}`))
}

export const getExportStatus = () => {
  return useApi(http.get(`/tickets/export/status`))
}

export const getExportHistory = (page = 1, limit = 10) => {
  return useApi(http.get(`/tickets/export/history?page=${page}&limit=${limit}`))
}

export const getExportDownloadUrl = (exportId: string) => {
  return useApi(http.get(`/tickets/export/download/${encodeURIComponent(exportId)}`))
}
